import { WithStyles, withStyles } from '@mui/styles';
import { SortModel } from '@tassat/common-definitions';
import { Location } from 'history';
import { RouteComponentProps } from 'react-router-dom';

import { FirmView } from './firmView';
import { muiStyles } from './firmViewStyles';

type RouteParams = {
    firmId: string;
    accountId: string;
    userId: string;
    accountWithdrawalDataId: any;
};

export interface IFirmViewProps extends
    WithStyles<typeof muiStyles>,
    RouteComponentProps<RouteParams> {
    location: Location<{
        sortModel?: SortModel;
        tab?: number;
    }>;
    setCurrentPage: () => void;
    setActiveCurrency: React.Dispatch<React.SetStateAction<number>>;
}

export const FIRM_VIEW_ACCOUNTS_TAB = 0;
export const FIRM_VIEW_WALLETS_TAB = 1;
export const FIRM_VIEW_DETAILS_TAB = 2;
export const FIRM_VIEW_USERS_TAB = 3;
export const FIRM_VIEW_ACTIVITY_TAB = 4;
export const FIRM_VIEW_WITHDRAWAL_INFO_TAB = 5;

export default withStyles(muiStyles)(FirmView);